export interface INotificationsState {
  list: INotification[];
}

export enum ENotificationType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Progress = 'progress',
  Spinner = 'spinner',
}

export interface INotification {
  id?: string;
  type: 'success' | 'error' | 'info' | 'progress' | 'spinner';
  text: string;
}
